import React from 'react'

import { incomeColumns, incomeTableData } from './IncomeData';

import DataTable from "../../../../../Common/DataTable/DataTable";
import DataTableHeader from "../../../../../Common/DataTableHeader/DataTableHeader";
import DataTableFooter from "../../../../../Common/DataTableFooter/DataTableFooter";
import Swal from 'sweetalert2';

const IncomeTable = () => {
    const sweet = () => {
        Swal.fire({
            title: 'Done!',
            text: 'Download Successfully',
            icon: 'success',
            confirmButtonText: 'Ok'
        })
    }

    const dataT = incomeTableData.map((data) => {
        return {
            description: <span className='flex items-center'>
                <svg width="30" height="30" viewBox="0 0 30 30"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    className="me-3 my-1">
                    <circle cx="15" cy="15" r="14"
                        stroke="#718EBF" strokeWidth="2">
                    </circle>
                    <path d="M15.5303 9.96967C15.2374 9.67678 14.7626 9.67678 14.4697 9.96967L9.6967 14.7426C9.40381 15.0355 9.40381 15.5104 9.6967 15.8033C9.98959 16.0962 10.4645 16.0962 10.7574 15.8033L15 11.5607L19.2426 15.8033C19.5355 16.0962 20.0104 16.0962 20.3033 15.8033C20.5962 15.5104 20.5962 15.0355 20.3033 14.7426L15.5303 9.96967ZM15.75 21L15.75 10.5L14.25 10.5L14.25 21L15.75 21Z"
                        fill="#718EBF"></path>
                </svg>
                <p>{data.description}</p>
            </span>,
            transactionId: data.transactionId,
            card: data.card,
            date: data.date,
            amount: (
                <>
                    <span className={`badge ${data.amountColor}`}>{data.amount}</span>
                </>
            ),
            receipt: (
                <>
                    <button
                        type="button"
                        onClick={sweet}
                        className="border border-primary hover:bg-primary hover:text-white duration-300 px-3 py-1"
                        style={{
                            boxShadow: '0 0 0 0.5px var(--tw-ring-color, currentColor)',
                            borderRadius: '9px',
                        }}
                    >
                        Download
                    </button>
                </>
            ),
        };
    });

    return (
        <div className='px-4'>
            <DataTableHeader />
            <DataTable columns={incomeColumns} data={dataT} />
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default IncomeTable;